import './WeeklyPlanTable.css';

const DAYS = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
const asArray = value => Array.isArray(value) ? value : [];
const asText = value => typeof value === 'string' || typeof value === 'number' ? String(value) : '';

const PeriodContent = ({ period, testId }) => {
  // Current plans store {subject, topic}; older plans may contain plain strings.
  const object = period && typeof period === 'object' && !Array.isArray(period);
  const subject = asText(object ? period.subject : period);
  const topic = asText(object ? period.topic : null);
  if (!subject && !topic) return <span className="weekly-plan-empty-cell" data-testid={`${testId}-empty`}>—</span>;
  return <>
    {subject && <strong data-testid={`${testId}-subject`}>{subject}</strong>}
    {topic && <span className="weekly-plan-topic" data-testid={`${testId}-topic`}>{topic}</span>}
  </>;
};

export const WeeklyPlanTable = ({ plan, testId, theme = 'light' }) => {
  const days = asArray(plan?.days);
  const labels = asArray(plan?.period_labels);
  const columnCount = days.reduce((count, day) => Math.max(count, asArray(day?.periods).length), labels.length);
  if (!days.length || !columnCount) return (
    <p className="weekly-plan-empty" data-testid={`${testId}-empty`}>لم تُضف حصص إلى هذه الخطة</p>
  );
  return (
    <div className="weekly-plan-view" data-theme={theme} dir="rtl" role="region" aria-label="جدول الخطة الأسبوعية" tabIndex={0} data-testid={`${testId}-scroll`}>
      <table data-testid={testId}>
        <caption className="sr-only">{asText(plan?.week_label) || 'الخطة الأسبوعية'}</caption>
        <thead><tr>
          <th scope="col" data-testid={`${testId}-day-heading`}>اليوم</th>
          {Array.from({ length: columnCount }, (_, index) => (
            <th scope="col" key={index} data-testid={`${testId}-period-heading-${index}`}>{asText(labels[index]) || `الحصة ${index + 1}`}</th>
          ))}
        </tr></thead>
        <tbody>{days.map((day, dayIndex) => (
          <tr key={dayIndex} data-testid={`${testId}-day-${dayIndex}`}>
            <th scope="row" data-testid={`${testId}-day-name-${dayIndex}`}>{asText(day?.day) || DAYS[dayIndex] || `يوم ${dayIndex + 1}`}</th>
            {Array.from({ length: columnCount }, (_, periodIndex) => (
              <td key={periodIndex} data-testid={`${testId}-cell-${dayIndex}-${periodIndex}`}>
                <PeriodContent period={asArray(day?.periods)[periodIndex]} testId={`${testId}-cell-${dayIndex}-${periodIndex}`} />
              </td>
            ))}
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
};